import React from 'react';
import { useSelector } from 'react-redux';
import { setClassNames } from 'ddc-classnames-js';
import { usePrefs, useLabels, useRequestData } from 'wsm-common-data';
import { Cta } from 'wsm-contact-ctas';
import Address from 'wsm-contact-address';

const Widget = () => {
	const { dealerInfo, contactInfo, mapLink } = useSelector((state) => state);
	const {
		mapButtonStyle,
		showCallLabel,
		mapButtonSize,
		mapButtonLayout,
		callButtonLayout,
		callButtonStyle,
		callButtonSize,
		addressClasses,
		displayAddressAbovePhoneNumbers,
		mapLinkLocation,
		enableAddressBackground,
		callButtonListClasses
	} = usePrefs();
	const labels = useLabels();
	const { deviceType, widgetName, windowId } = useRequestData();
	const ctaProps = {
		labels,
		contactInfo,
		widgetName,
		windowId,
		mapLink: mapLink && mapLinkLocation === 'phone section' ? mapLink : '',
		accountId: dealerInfo.accountId,
		ctaPrefs: {
			mapButtonStyle,
			mapButtonSize,
			mapButtonLayout,
			callButtonLayout,
			callButtonStyle,
			callButtonSize,
			callButtonListClasses
		},
		ctaLabels: {
			CALL: labels.get('CALL'),
			GET_DIRECTIONS: labels.get('GET_DIRECTIONS')
		},
		isMobile: deviceType === 'MOBILE',
		showCallLabel: showCallLabel === 'true'
	};

	const addressElementClasses = [
		...addressClasses.split(' '),
		...(enableAddressBackground === 'true' ? ['text-black', 'my-3'] : [])
	];

	const addressProps = {
		...dealerInfo,
		addressClasses: setClassNames(addressElementClasses) || '',
		// For offsite inventory when mapLinkLocation is set to 'address section'
		// we override the vehicle's website URL with the directions link
		...(mapLink &&
			mapLinkLocation === 'address section' && {
				url: {
					link: mapLink,
					text: ctaProps.ctaLabels.GET_DIRECTIONS
				}
			})
	};

	const addressMarkup =
		enableAddressBackground === 'true' ? (
			<div className="bg-location bg-neutral-0 d-flex border p-4 mx-4 mb-4">
				<div className="d-sm-inline mx-4">
					<i
						className="ddc-icon ddc-icon-map ddc-font-size-xlarge text-black"
						aria-hidden="true"
					/>
				</div>
				<Address {...addressProps} />
			</div>
		) : (
			<Address {...addressProps} />
		);

	const markup =
		displayAddressAbovePhoneNumbers === 'true' ? (
			<React.Fragment>
				{addressMarkup}
				<Cta {...ctaProps} />
			</React.Fragment>
		) : (
			<React.Fragment>
				<Cta {...ctaProps} />
				{addressMarkup}
			</React.Fragment>
		);

	return markup;
};

export default Widget;
